module.exports = __webpack_public_path__ + "static/img/128.93d1b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/128.jpg
// module id = 8yVK
// module chunks = 1